var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/**
 * Immutably adds an item(s) to the end of the array
 *
 * @category Array
 * @param {T[]} array - The original array
 * @param {...*} items - The item(s) to add
 * @returns {T[]} - The new array
 * @example
 * const array = ['dog', 'cat', 'bird'];
 * push(array, 'fish');
 * // => ['dog', 'cat', 'bird', 'fish']
 * @docgen_example
 * const array = ['dog', 'cat', 'bird'];
 * push(array, 'fish');
 */
export var push = function (array) {
    var items = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        items[_i - 1] = arguments[_i];
    }
    return !array || array.length <= 0 ? __spreadArray([], items, true) : __spreadArray(__spreadArray([], array, true), items, true);
};
